var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeingHumanImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.46 104.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-2);}.cls-2,.cls-5{mix-blend-mode:multiply;}.cls-2{fill:url(#radial-gradient);}.cls-3{isolation:isolate;}.cls-4{mask:url(#mask-2);}.cls-5{fill:url(#radial-gradient-2);}.cls-6{fill:#217671;}.cls-7{fill:#f6f6f6;}.cls-8{fill:#3c3c3b;}.cls-9{fill:#30225f;}.cls-10{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: -8179.79,
    width: 89.28,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: -8179.79,
    width: 89.28,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 254.44,
    cy: -343.7,
    r: 37.83,
    gradientTransform: "translate(-360.96 -255.66) rotate(90) scale(1.18 1.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 0,
    y: 0,
    width: 89.28,
    height: 89.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 0,
    y: 0,
    width: 89.28,
    height: 89.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.2,76.21a44.64,44.64,0,1,1,0-63.14A44.65,44.65,0,0,1,76.2,76.21Z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 254.44,
    cy: -343.7,
    r: 37.83,
    gradientTransform: "translate(-360.96 -255.66) rotate(90) scale(1.18 1.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1f1f1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#272725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#353533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#484846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#61615f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#80807e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a4a4a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About_Us_Page",
    "data-name": "About Us Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Our_principles",
    "data-name": "Our principles"
  }, /*#__PURE__*/React.createElement("g", {
    id: "being_Human_Image",
    "data-name": "being Human Image"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.2,76.21a44.64,44.64,0,1,1,0-63.14A44.65,44.65,0,0,1,76.2,76.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.78,76.63A38.41,38.41,0,1,1,85,53.58,38.4,38.4,0,0,1,35.78,76.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.86,66A30.38,30.38,0,1,0,23,24.19,30.39,30.39,0,0,0,32.86,66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.87,88.61a2.95,2.95,0,1,1-2.95-3A2.95,2.95,0,0,1,50.87,88.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M93.13,57.9a47.34,47.34,0,0,1-88.27,0H4.14a48,48,0,0,0,89.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M7.3,58.64a3.16,3.16,0,1,1-3.16-3.17A3.15,3.15,0,0,1,7.3,58.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.46,57.9A2.95,2.95,0,1,1,93.52,55,2.94,2.94,0,0,1,96.46,57.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 47.52,
    y: 87.9,
    width: 0.73,
    height: 7.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.34,100a2.39,2.39,0,0,1-4.77,0,2.39,2.39,0,1,1,4.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.92,104.9A4.93,4.93,0,1,1,52.85,100,4.93,4.93,0,0,1,47.92,104.9Zm0-9.51A4.59,4.59,0,1,0,52.51,100,4.58,4.58,0,0,0,47.92,95.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.18,58.1a.52.52,0,0,1-.52-.52V54.73H37.15v2.85a.52.52,0,0,1-.52.52.53.53,0,0,1-.52-.52V54.22a.52.52,0,0,1,.52-.52h9.55a.52.52,0,0,1,.52.52v3.36A.52.52,0,0,1,46.18,58.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.05,58.1a.52.52,0,0,1-.52-.52V54.73H51v2.85a.52.52,0,0,1-1,0V54.22a.52.52,0,0,1,.52-.52h9.55a.52.52,0,0,1,.52.52v3.36A.53.53,0,0,1,60.05,58.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.43,52.66l-5.92-5.92a.65.65,0,0,1-.18-.44l-.3-10c0-.05,0-.09.13-.13a2.19,2.19,0,0,1,1.94,2.17l.69,4.95,1-.14s-.41-3-.7-5a3.17,3.17,0,0,0-2.81-3,1.14,1.14,0,0,0-.93.27,1.18,1.18,0,0,0-.39.91l.3,10a1.65,1.65,0,0,0,.49,1.13L37,52.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.18,58.1a.52.52,0,0,1-.52-.52V54.73H37.15v2.85a.52.52,0,0,1-.52.52.53.53,0,0,1-.52-.52V54.22a.52.52,0,0,1,.52-.52h9.55a.52.52,0,0,1,.52.52v3.36A.52.52,0,0,1,46.18,58.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44,56.5a.62.62,0,0,1-1.24,0,.62.62,0,1,1,1.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.05,58.1a.52.52,0,0,1-.52-.52V54.73H51v2.85a.52.52,0,0,1-1,0V54.22a.52.52,0,0,1,.52-.52h9.55a.52.52,0,0,1,.52.52v3.36A.53.53,0,0,1,60.05,58.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.64,56.5a.62.62,0,0,0,1.24,0,.62.62,0,1,0-1.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.45,25.78a2.36,2.36,0,1,1,2.36-2.36A2.36,2.36,0,0,1,42.45,25.78Zm0-3.68a1.32,1.32,0,1,0,1.33,1.32A1.32,1.32,0,0,0,42.45,22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54.71,25.78a2.36,2.36,0,1,1,2.36-2.36A2.36,2.36,0,0,1,54.71,25.78Zm0-3.68A1.32,1.32,0,1,0,56,23.42,1.33,1.33,0,0,0,54.71,22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.75,35.76a.62.62,0,0,0-.53-.48c-.64-.09-1.33-.39-1.36-.83l-.39-5.34a1.41,1.41,0,0,1,1.34-1.43h4.88a1.39,1.39,0,0,1,.62.16,3.16,3.16,0,0,1-.13-.87,2.48,2.48,0,0,1,0-.27,3,3,0,0,0-.51-.06H39.79a2.47,2.47,0,0,0-2.36,2.51l.4,5.38c.06,1,1,1.51,1.92,1.72l.53,7.23a.61.61,0,0,0,.57.52.52.52,0,0,0,.52-.52.55.55,0,0,0-.07-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.64,39.75l-.26,3.52a.54.54,0,0,0-.05.21.52.52,0,0,0,.52.52.58.58,0,0,0,.55-.51l.22-3A3.3,3.3,0,0,1,43.64,39.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.58,29.33A2.36,2.36,0,1,1,50.94,27,2.36,2.36,0,0,1,48.58,29.33Zm0-3.68A1.33,1.33,0,1,0,49.9,27,1.32,1.32,0,0,0,48.58,25.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.93,47.55a.52.52,0,0,1-.52-.48l-.54-7.27c-.93-.21-1.85-.75-1.92-1.72l-.39-5.38a2.47,2.47,0,0,1,2.36-2.51h4.91a2.62,2.62,0,0,1,2.54,2.48v.11L53,38.09c-.07,1-1,1.5-1.91,1.71l-.53,7.26a.55.55,0,0,1-.54.49.51.51,0,0,1-.52-.51.47.47,0,0,1,0-.17l.56-7.55a.51.51,0,0,1,.48-.48c.68-.1,1.36-.4,1.39-.83l.4-5.29a1.57,1.57,0,0,0-1.52-1.49H45.93a1.42,1.42,0,0,0-1.34,1.43L45,38c0,.43.72.73,1.36.82a.63.63,0,0,1,.53.49L47.45,47a.52.52,0,0,1-.48.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57,26.9H52s0,0,0,.06a3.33,3.33,0,0,1-.17,1l.25,0h4.88a1.58,1.58,0,0,1,1.52,1.5l-.4,5.29c0,.43-.72.73-1.41.83a.51.51,0,0,0-.47.47l-.56,7.68a.52.52,0,0,0,.48.56h0a.52.52,0,0,0,.51-.48l.54-7.27c.92-.21,1.83-.75,1.91-1.72l.39-5.29v-.13A2.61,2.61,0,0,0,57,26.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.29,40.46l.25,3.32a.53.53,0,0,0,.55.48.52.52,0,0,0,.48-.56l-.29-3.94A3.15,3.15,0,0,1,52.29,40.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.87,49.26a.53.53,0,0,0,0-.74l-4-4v-.12a1.51,1.51,0,0,1,2.1,0l2.13,2.13a.51.51,0,0,0,.26.14,5.43,5.43,0,0,1,3.32,1.83,5.35,5.35,0,0,1,1.44,4.13h1a6.75,6.75,0,0,0-5.43-6.95l-2-2a2.54,2.54,0,0,0-3.43-.16,1.14,1.14,0,0,0-.46.81,1.13,1.13,0,0,0,.33.89l4,4A.53.53,0,0,0,38.87,49.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M62.44,43.53a2.54,2.54,0,0,0-3.43.16l-2,2a6.75,6.75,0,0,0-5.43,6.95h1A5.35,5.35,0,0,1,54,48.53a5.43,5.43,0,0,1,3.32-1.83.51.51,0,0,0,.26-.14l2.13-2.13a1.51,1.51,0,0,1,2.1,0l.3-.43-.3.55-4,4a.52.52,0,0,0,.74.74l4-4a1.13,1.13,0,0,0,.33-.89A1.14,1.14,0,0,0,62.44,43.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.29,35.46a1.15,1.15,0,0,0-.92-.27,3.17,3.17,0,0,0-2.81,3c-.29,2-.7,5-.7,5l1,.14.69-4.95a2.14,2.14,0,0,1,2-2.14.16.16,0,0,1,0,.1l-.3,10a.65.65,0,0,1-.18.44l-5.92,5.92h1.47l5.18-5.19a1.65,1.65,0,0,0,.49-1.13l.3-10A1.15,1.15,0,0,0,65.29,35.46Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeingHumanImage);
export default __webpack_public_path__ + "static/media/being-human-image.0a1e74f18d4c1e34a41e6a020bfa2bc4.svg";
export { ForwardRef as ReactComponent };